import { fromJS, Set, Map } from 'immutable';

import {
    ADD_CS_FILTER,
    CLEAR_CS_FILTERS,
    GET_CASESTUDY_START,
    GET_CASESTUDY_SUCCESS,
    GET_CASESTUDY_ERROR,
} from './caseStudy.action';

const initialState = fromJS({
    filters: new Set(),
    caseStudy: {},
    caseStudyInit: false,
    caseStudyLoading: false,
});

export const caseStudy = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CS_FILTER:
            return state.withMutations(ctx => {
                const { filter } = action.payload;
                const filters = ctx.get('filters');
                const thisFilter = Array.from(filters).filter(f => f.type === filter.type && f.value === filter.value);
                if (thisFilter.length > 0) {
                    ctx.set('filters', filters.delete(thisFilter[0]));
                } else {
                    ctx.set('filters', filters.add(filter));
                }
            });
        case CLEAR_CS_FILTERS:
            return state.withMutations(ctx => {
                const { type } = action.payload;
                const filters = ctx.get('filters');
                if (type === '') {
                    ctx.set('filters', new Set());
                } else {
                    const newFilters = Array.from(filters).filter(f => f.type !== type);
                    ctx.set('filters', new Set(newFilters));
                }
            });
        case GET_CASESTUDY_START:
            return state.withMutations(ctx => {
                ctx.set('caseStudyInit', true);
                ctx.set('caseStudyLoading', true);
                ctx.set('caseStudy', new Map({}));
            });
        case GET_CASESTUDY_SUCCESS:
            return state.withMutations(ctx => {
                ctx.set('caseStudyLoading', false);
                ctx.set('caseStudy', new Map(action.payload.data));
            });
        case GET_CASESTUDY_ERROR:
            return state.withMutations(ctx => {
                ctx.set('caseStudyLoading', true);
                ctx.set('caseStudy', new Map({}));
            });
        default:
            return state;
    }
};
